export function fetchReceived(idLeague) { return { type: 'MESSAGES/RECEIVED/FETCH', idLeague } }
export function fetchSent(idLeague) { return { type: 'MESSAGES/SENT/FETCH', idLeague } }